<template>
  <div class="bookFair text-NotoSansRegular mx-auto">
    <nav class="main-bg">
      <div class="py-4 lg:py-6 px-4 lg:px-6 max-w-5xl mx-auto">
        <nav class="flex items-center">
          <router-link :to="{ name: 'index'}" class="flex items-center w-32 md:w-auto">
            <img src="~@/assets/images/samsung/pic_liveabc_logo.png" class="object-contain max-w-full w-full">
          </router-link>
        </nav>
      </div>
    </nav>
    <div class="main w-full">
      <div class="banner main-bg relative overflow-hidden pt-10 md:pt-8 mb-2 md:mb-6">
        <div class="max-w-5xl mx-auto z-40 flex justify-center items-center px-4">
          <div class="z-40">
            <img src="~@/assets/images/bookFair2020/boy-left.png" class="w-full z-40 h-auto maw-full"  data-aos="fade-right" data-aos-easing="ease" data-aos-once="true" data-aos-offset="100" data-aos-delay="400">
          </div>
          <div class="z-20 title-item relative">
            <img src="~@/assets/images/bookFair2020/title.png" class="w-full z-40 h-auto maw-full" data-aos="fade-in" data-aos-easing="ease" data-aos-once="true" data-aos-offset="100">
          </div>
          <div class="z-40">
            <img src="~@/assets/images/bookFair2020/girl-right.png" class="w-full z-40 h-auto maw-full" data-aos="fade-left" data-aos-easing="ease" data-aos-once="true" data-aos-offset="100" data-aos-delay="400">
          </div>
        </div>
      </div>
      <div class="recommend relative z-40 px-4">
        <div class="border-2 border-blue-800 shadow-bookFair max-w-5xl mx-auto rounded-lg flex flex-col z-40 bg-white overflow-hidden">
          <div class="livePen px-6 py-4 md:px-8 md:py-6 border-b-2 border-blue-800 border-dashed relative">
            <div class="flex flex-wrap justify-center">
              <div class="w-4/5 mb-4 md:px-8">
                <img src="~@/assets/images/bookFair2020/title-2.png" class="object-contain max-w-full mx-auto h-auto" data-aos="fade-in" data-aos-easing="ease" data-aos-once="true" data-aos-offset="100">
              </div>
              <div class="w-full sm:w-1/3 p-2 md:p-4" v-for="(item, index) in livePenRecommend" :key="index">
                <router-link target="_blank" :to="{ name: 'detail', params: { category: 'package', id: item.id } }">
                  <img :src="item.img_url" class="object-contain max-w-full mx-auto" data-aos="fade-in" data-aos-easing="ease" data-aos-once="true" data-aos-offset="100">
                </router-link>
              </div>
            </div>
            <router-link target="_blank" :to="{ name: 'productsList', params: { category: 'package' }, query: { scope: 'smartpen_package_series' } }" class="absolute more">
              <img src="~@/assets/images/bookFair2020/more.png" class="object-contain max-w-full mx-auto hidden md:block" data-aos="fade-in" data-aos-easing="ease" data-aos-once="true" data-aos-offset="100">
              <img src="~@/assets/images/bookFair2020/more-m.png" class="object-contain max-w-full mx-auto md:hidden" data-aos="fade-in" data-aos-easing="ease" data-aos-once="true" data-aos-offset="100">
            </router-link>
          </div>
          <div class="package px-6 py-4 md:px-8 md:py-6 flex justify-center bg-white relative">
            <div class="flex flex-wrap justify-center">
              <div class="w-4/5 mb-4 md:px-8">
                <img src="~@/assets/images/bookFair2020/title-3.png" class="object-contain max-w-full mx-auto" data-aos="fade-in" data-aos-easing="ease" data-aos-once="true" data-aos-offset="100">
              </div>
              <div class="w-full sm:w-1/3 p-2 md:p-4" v-for="(item, index) in packageRecommend" :key="index">
                <router-link target="_blank" :to="{ name: 'detail', params: { category: 'package', id: item.id } }">
                  <img :src="item.img_url" class="object-contain max-w-full mx-auto" data-aos="fade-in" data-aos-easing="ease" data-aos-once="true" data-aos-offset="100">
                </router-link>
              </div>
            </div>
            <router-link target="_blank" :to="{ name: 'productsList', params: { category: 'package' }, query: { scope: 'classic_package_series' } }" class="absolute more">
              <img src="~@/assets/images/bookFair2020/more.png" class="object-contain max-w-full mx-auto hidden md:block" data-aos="fade-in" data-aos-easing="ease" data-aos-once="true" data-aos-offset="100">
              <img src="~@/assets/images/bookFair2020/more-m.png" class="object-contain max-w-full mx-auto md:hidden" data-aos="fade-in" data-aos-easing="ease" data-aos-once="true" data-aos-offset="100">
            </router-link>
          </div>
        </div>
      </div>
      <div class="featured main-bg">
        <div class="max-w-5xl mx-auto py-6 md:py-10">
          <h6 class="text-center text-2xl md:text-3xl text-blue-800 mb-4 text-NotoSansBold tracking-wide">精選叢書</h6>
          <div class="flex flex-wrap">
            <div class="w-1/3 md:w-1/4 p-2 cursor-pointer item" v-for="(item, index) in featureBooks" :key="index">
              <router-link target="_blank" v-if="item.type === 'book'" :to="{ name: 'productsList', params: { category: 'book' }, query: { type: 'BOOK', category: item.category_id } }">
                <img :src="item.img_url" class="object-contain max-w-full mx-auto notHover" data-aos="fade-in" data-aos-easing="ease" data-aos-once="true" data-aos-offset="100">
                <img :src="item.img_url_hover" class="object-contain max-w-full mx-auto onHover" data-aos="fade-in" data-aos-easing="ease" data-aos-once="true" data-aos-offset="100">
              </router-link>
              <router-link target="_blank" v-if="item.type === 'package'" :to="{ name: 'productsList', params: { category: 'package' }, query: { type: 'PACKAGE', scope: item.scope } }">
                <img :src="item.img_url" class="object-contain max-w-full mx-auto notHover" data-aos="fade-in" data-aos-easing="ease" data-aos-once="true" data-aos-offset="100">
                <img :src="item.img_url_hover" class="object-contain max-w-full mx-auto onHover" data-aos="fade-in" data-aos-easing="ease" data-aos-once="true" data-aos-offset="100">
              </router-link>
              <router-link target="_blank" v-if="item.type === 'item'" :to="{ name: 'productsList', params: { category: 'package' }, query: { type: 'ITEM', category: item.category_id } }">
                <img :src="item.img_url" class="object-contain max-w-full mx-auto notHover" data-aos="fade-in" data-aos-easing="ease" data-aos-once="true" data-aos-offset="100">
                <img :src="item.img_url_hover" class="object-contain max-w-full mx-auto onHover" data-aos="fade-in" data-aos-easing="ease" data-aos-once="true" data-aos-offset="100">
              </router-link>
            </div>
          </div>
        </div>
      </div>
      <div class="attention main-bg py-12">
        <div class="max-w-5xl mx-auto">
          <div class="flex flex-wrap items-center justify-between">
            <div class="w-full md:w-3/5 font-bold leading-relaxed px-4 mb-4 md:mb-0 tracking-wide">
              <h6>注意事項：</h6>
              <p>1.LiveABC互動英語教學集團保有修改、暫停或終止本活動之權利。</p>
              <p>2.此開學書展折扣活動，恕不與網站其他商品做共同搭配滿額計算。</p>
              <p>3.部分新書、校園專用書籍及雜誌系列恕不列入本活動優惠。</p>
            </div>
            <div class="w-full md:w-2/5 flex justify-end">
              <img src="~@/assets/images/bookFair2020/girl-down.png" class="object-contain max-w-full z-40">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'BookFair2020',
  metaInfo () {
    return {
      title: '開學書展大作戰',
      titleTemplate: null
    }
  },
  data () {
    return {
      livePenRecommend: [
        { id: 5936, img_url: require('@/assets/images/bookFair2020/pen-suit (1).png') },
        { id: 6561, img_url: require('@/assets/images/bookFair2020/pen-suit (2).png') },
        { id: 6758, img_url: require('@/assets/images/bookFair2020/pen-suit (3).png') },
        { id: 6770, img_url: require('@/assets/images/bookFair2020/pen-suit (4).png') },
        { id: 6569, img_url: require('@/assets/images/bookFair2020/pen-suit (5).png') }
      ],
      packageRecommend: [
        { id: 6590, img_url: require('@/assets/images/bookFair2020/suit (1).png') },
        { id: 6598, img_url: require('@/assets/images/bookFair2020/suit (2).png') },
        { id: 6554, img_url: require('@/assets/images/bookFair2020/suit (3).png') },
        { id: 6562, img_url: require('@/assets/images/bookFair2020/suit (4).png') },
        { id: 6556, img_url: require('@/assets/images/bookFair2020/suit (5).png') }
      ],
      featureBooks: [
        { type: 'book', category_id: 111, img_url: require('@/assets/images/bookFair2020/B-1.png'), img_url_hover: require('@/assets/images/bookFair2020/W-1.png') },
        { type: 'book', category_id: 110, img_url: require('@/assets/images/bookFair2020/B-2.png'), img_url_hover: require('@/assets/images/bookFair2020/W-2.png') },
        { type: 'book', category_id: 108, img_url: require('@/assets/images/bookFair2020/B-3.png'), img_url_hover: require('@/assets/images/bookFair2020/W-3.png') },
        { type: 'book', category_id: 112, img_url: require('@/assets/images/bookFair2020/B-4.png'), img_url_hover: require('@/assets/images/bookFair2020/W-4.png') },
        { type: 'book', category_id: 117, img_url: require('@/assets/images/bookFair2020/B-5.png'), img_url_hover: require('@/assets/images/bookFair2020/W-5.png') },
        { type: 'book', category_id: 115, img_url: require('@/assets/images/bookFair2020/B-6.png'), img_url_hover: require('@/assets/images/bookFair2020/W-6.png') },
        { type: 'book', category_id: 107, img_url: require('@/assets/images/bookFair2020/B-7.png'), img_url_hover: require('@/assets/images/bookFair2020/W-7.png') },
        { type: 'book', category_id: 103, img_url: require('@/assets/images/bookFair2020/B-8.png'), img_url_hover: require('@/assets/images/bookFair2020/W-8.png') },
        { type: 'book', category_id: 105, img_url: require('@/assets/images/bookFair2020/B-9.png'), img_url_hover: require('@/assets/images/bookFair2020/W-9.png') },
        { type: 'item', category_id: 141, img_url: require('@/assets/images/bookFair2020/B-10.png'), img_url_hover: require('@/assets/images/bookFair2020/W-10.png') },
        { type: 'package', scope: 'classic_package_series', img_url: require('@/assets/images/bookFair2020/B-11.png'), img_url_hover: require('@/assets/images/bookFair2020/W-11.png') },
        { type: 'package', scope: 'smartpen_package_series', img_url: require('@/assets/images/bookFair2020/B-12.png'), img_url_hover: require('@/assets/images/bookFair2020/W-12.png') }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.main-bg {
  background-color: #ffdc3a;
}
.banner {
  .title-item {
    &:after {
      content: '';
      width: 30em;
      height: 30em;
      top: -4rem;
      left: 50%;
      transform: translateX(-50%);
      position: absolute;
      background-color: #ffffff;
      z-index: -2;
      border-radius: 50%;
    }

    @media (max-width: 576px) {
      &:after {
        content: '';
        width: 20em;
        height: 20em;
        top: -2rem;
        left: 50%;
        transform: translateX(-50%);
        position: absolute;
        background-color: #ffffff;
        z-index: -2;
        border-radius: 50%;
      }
    }
  }
  &:before {
    content: '';
    width: 100%;
    height: 14%;
    left: 0;
    bottom: 0;
    position: absolute;
    background-color: #ffffff;
    z-index: 0;
  }
}
.shadow-bookFair {
  box-shadow: 5px 5px 7px rgba(0, 0, 0, 0.4);
}
.salePrice {
  .item {
    h5 {
      text-shadow: 2px 2px rgba(0, 0, 0, 0.3);
    }
  }
  .shadowItem {
    &:after {
      content: '';
      width: 1px;
      height: 60%;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
      position: absolute;
      z-index: 2;
      background-color: #ffdc3a;
    }
  }
}
.more {
  bottom: 6%;
  right: 5%;
  @media (max-width: 768px) {
    bottom: 2%;
    right: 5%;
  }
}

.recommend {
  &:after {
    content: '';
    width: 100%;
    height: 5%;
    left: 0;
    bottom: 0;
    position: absolute;
    background-color: #ffdc3a;
    z-index: -1;
  }
}
.featured {
  .item {
    .onHover {
      display: none;
    }
    &:hover {
      .notHover {
        display: none;
      }
      .onHover {
        display: block;
      }
    }
  }

}
</style>
